import store from '../../redux/store';
import analyticsClient from '../analyticsClient';
import detectBrowserLanguage from '../language/detectBrowserLanguage';
import * as momentUtils from '../../utils/momentUtils';

const browserLocale = detectBrowserLanguage();

export default class EventSender {
  static sendEvent(event) {
    const state = store.getState();
    const payload = {
      recordedAt: momentUtils.getNow(),
      userId: state.persist.session.userId,
      path: state.nav.currentPath,
      // appInstallationId: state.persist.app.appInstallationId, // visitor_id in database
      // include code and clusterId in your event if you want to overwrite these
      code: state.persist.landing.code,
      clusterId: state.persist.landing.clusterId,
      // TODO: add more default data here
      browserLocale,
      ...event,
    };

    analyticsClient.post('', payload).catch(() => {
      /* silence analytics errors */
    });
  }
}
